import { makeStyles } from 'tss-react/mui';

const useStylesFieldSeparatedBlock: MaterialUIStylesCallback = makeStyles()((): MaterialUIStyles => ({
  fieldSeparatedBlock: {
    '& > div': {
      '&:first-of-type': {
        width: '65%',
      },
      '&:last-of-type': {
        width: '35%',
      },
    },
  },
  fieldSeparatedBlockOffset: {
    '& > div:last-of-type': {
      marginLeft: 5,
    },
  },
}));

export default useStylesFieldSeparatedBlock;
